import {useState} from 'react'
import {useSearchParams} from 'react-router-dom'
import {ROWS_PER_PAGE_SELECTOR} from '@constants'
import {useEffect} from 'react'

export default function usePagination() {
  const [pagination, setPagination] = useState({})
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const page = searchParams.get('page') || 0
    const count = searchParams.get('count') || ROWS_PER_PAGE_SELECTOR[1]
    setPagination({
      count,
      pageNumbers: Array.from(Array(Number(page) + 1).keys()).slice(1),
      rowsPerPage: ROWS_PER_PAGE_SELECTOR[0],
      currentPage: Number(page),
      totalCount: 0,
      rowsPerPageOptions: ROWS_PER_PAGE_SELECTOR,
    })
  }, [])

  const handlePageChange = pageNumber => {
    const selectedPage = pageNumber - 1
    searchParams.set('page', selectedPage)
    setSearchParams(searchParams)
    setPagination({...pagination, currentPage: selectedPage})
  }

  const handleRowsPerPageChanged = selectedRowsPerPage => {
    searchParams.set('count', selectedRowsPerPage)
    searchParams.set('page', 0)
    setSearchParams(searchParams)
    setPagination({...pagination, rowsPerPage: selectedRowsPerPage, currentPage: 0})
  }

  const updatePaginationMetaData = paginationMetaData => {
    const pageNumbers = Math.ceil(paginationMetaData?.totalCount / paginationMetaData?.pageSize) || 1
    setPagination({
      ...pagination,
      currentPage: Number(searchParams.get('page')) + 1,
      pageNumbers: Array.from(Array(Number(pageNumbers) + 1).keys()).slice(1),
      rowsPerPage: paginationMetaData?.pageSize,
      totalCount: paginationMetaData?.totalCount,
      rowsPerPageOptions: ROWS_PER_PAGE_SELECTOR,
    })
  }
  return {
    page: searchParams.get('page'),
    count: searchParams.get('count'),
    pagination,
    updatePaginationMetaData,
    handlePageChange,
    handleRowsPerPageChanged,
  }
}
